import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { buttonClasses } from '@/components/generals/button-link'

const HIDE_NEAR = ['hero', 'aanmelden', 'start', 'footer']

export const MobileCta: FC = (): ReactNode => {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const inView = new Set<string>()
        const targets = HIDE_NEAR
            .map(id => document.getElementById(id))
            .filter((element): element is HTMLElement => element !== null)

        if (targets.length === 0) return

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) inView.add(entry.target.id)
                else inView.delete(entry.target.id)
            })

            setVisible(inView.size === 0)
        }, { rootMargin: '0px 0px -10% 0px' })

        targets.forEach(target => observer.observe(target))

        return () => observer.disconnect()
    }, [])

    return (
        <div
            className={cn(
                'fixed inset-x-0 bottom-0 z-30 border-t border-ink/10 bg-paper/90 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] backdrop-blur-md transition-transform duration-300 sm:hidden',
                visible ? 'translate-y-0' : 'pointer-events-none translate-y-full'
            )}
            aria-hidden={!visible}
        >
            <a href='#aanmelden' tabIndex={visible ? 0 : -1} className={buttonClasses('primary', 'md', 'w-full')}>
                Start gratis met je klas
                <ArrowRight className='size-4' aria-hidden='true' />
            </a>
        </div>
    )
}
